export default __webpack_public_path__ + "static/media/hotel_awards.96841b37.png";